import Vue from 'vue'
import App from './App.vue'
import TimeAgo from 'javascript-time-ago'
import de from 'javascript-time-ago/locale/de'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueDateFns from 'vue-date-fns'
import axios from './assets/axios'
import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'
import VueScrollTo from 'vue-scroll-to'

TimeAgo.addDefaultLocale(de)

Vue.prototype.$http = axios
Vue.prototype.$timeAgo = new TimeAgo('de-DE')
Vue.config.productionTip = false

Vue.use(VueDateFns)
Vue.use(ToastPlugin)
Vue.use(VueScrollTo)

new Vue({
    router,
    store,
    beforeCreate() {
        this.$store.dispatch('init')
    },
    render: h => h(App),
}).$mount('#app')
